import { render, staticRenderFns } from "./CommentWideTable.vue?vue&type=template&id=514b5882&scoped=true&"
import script from "./CommentWideTable.vue?vue&type=script&lang=ts&"
export * from "./CommentWideTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommentWideTable.vue?vue&type=style&index=0&id=514b5882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514b5882",
  null
  
)

export default component.exports